// ABOUTME: Shared severity definitions + palette resolution for notices.
// ABOUTME: info follows the codebase convention (primary in light / blue in dark). warning + urgent are mode-independent.

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

export const SEVERITY_OPTIONS = [
    { id: "info", label: "info", getPaletteKey: (mode) => (mode === "dark" ? "blue" : "primary"), Icon: InfoOutlinedIcon },
    { id: "warning", label: "warning", getPaletteKey: () => "orange", Icon: WarningAmberOutlinedIcon },
    { id: "urgent", label: "urgent", getPaletteKey: () => "red", Icon: ReportProblemOutlinedIcon },
];

export const findSeverity = (id) => SEVERITY_OPTIONS.find((o) => o.id === id) || null;

export const getSeverityPalette = (severityId, mode, colors) => {
    const opt = findSeverity(severityId);
    if (!opt) return null;
    return colors[opt.getPaletteKey(mode)];
};
